module.exports = __webpack_public_path__ + "static/img/1.d3be8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/1.png
// module id = yYBK
// module chunks = 12